<template>
  <CommonLayout header="floristHeader" footer="floristFooter" ref="commonRef">
    <MeetingLayout :type="consts.meetingType.florist">
      <div class="base-color h-100 mh-550 shadow">
        <div class="customer-info-wrap h-100">
          <h2 class="text-primary pt-3 customer-info-title">【お客様情報入力欄】</h2>
          <form method="post" action="#" class="form-horizontal" autocomplete="off">
            <div class="p-3 mb-3">
              <div class="row">
                <div class="control-label col-sm-12 customer-info-label mb-1">
                  <h2 class="fw-bold d-inline">ご両家様名</h2>
                  <span class="required-color d-inline">（*）</span>
                </div>
                <div class="customer-info-block col-4 col-sm-4">
                  <input name="bothFamilyName1" type="text" id="bothFamilyName1" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.bothFamilyName1.$error}" v-model="state.bothFamilyName1" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                  <div class="invalid-feedback" v-for="error of v$.bothFamilyName1.$errors" :key="error.$uid">{{ error.$message }}</div>
                </div>
                <div class="col-1 col-sm-1 p-2 text-center">
                  <span>・</span>
                </div>
                <div class="customer-info-block col-4 col-sm-4">
                  <input name="bothFamilyName2" type="text" id="bothFamilyName2" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.bothFamilyName2.$error}" v-model="state.bothFamilyName2" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                  <div class="invalid-feedback" v-for="error of v$.bothFamilyName2.$errors" :key="error.$uid">{{ error.$message }}</div>
                </div>
                <div class="col-3 col-sm-3 p-2">
                  <span>ご両家様</span>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 customer-info-label">
                  <BFormRadioGroup
                    v-model="state.shinroShinpu1"
                    name= "shinroShinpu1"
                    @change="onRadioChange('shinroShinpu1', state.shinroShinpu1)"
                    :disabled="!state.isOperationPossible"
                    :class="{'is-invalid': v$.shinroShinpu1.$error}"
                  >
                    <BFormRadio id="shinroShinpu1-shinro" value="shinro" class="big_radio d-inline-flex align-items-center" style="block-size: 1.5rem; inline-size: 1.5rem; margin-top: 25%;">
                      <label for="shinroShinpu1-shinro" class="form-check-label ms-1 customer-info-label fw-bold" :style="'font-size: 2rem;' + (state.shinroShinpu1 !== 'shinro' ? 'color: gray;' : 'color: black;')">ご新郎様</label>
                    </BFormRadio>
                    <BFormRadio id="shinroAhinpu1-shinpu" value="shinpu" class="big_radio d-inline-flex align-items-center" style="block-size: 1.5rem; inline-size: 1.5rem; margin-top: 25%;">
                      <label for="shinroAhinpu1-shinpu" class="form-check-label ms-1 customer-info-label fw-bold" :style="'font-size: 2rem;' + (state.shinroShinpu1 !== 'shinpu' ? 'color: gray;' : 'color: black;')">ご新婦様</label>
                    </BFormRadio>
                  </BFormRadioGroup>
                </div>
                <div class="customer-info-block col-sm-5 row">
                  <label for="groomLastName" class="control-label col-sm-12">姓<span class="required-color">（*）</span></label>
                  <div class="col-sm-12">
                    <input name="groomLastName" type="text" id="groomLastName" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.groomLastName.$error}" v-model="state.groomLastName" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                    <div class="invalid-feedback" v-for="error of v$.groomLastName.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="customer-info-block col-sm-5 row">
                  <label for="groomFirstName" class="control-label col-sm-12">名<span class="required-color">（*）</span></label>
                  <div class="col-sm-12">
                    <input name="groomFirstName" type="text" id="groomFirstName" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.groomFirstName.$error}" v-model="state.groomFirstName" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                    <div class="invalid-feedback" v-for="error of v$.groomFirstName.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-sm-1 row">
                  <div class="col-sm-12"></div>
                  <div class="w-100 text-end align-self-center pt-3">様</div>
                </div>
                <div class="customer-info-block col-sm-5 row mt-2">
                  <label for="groomLastNameKana" class="control-label col-sm-12">セイ</label>
                  <div class="col-sm-12">
                    <input name="groomLastNameKana" type="text" id="groomLastNameKana" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.groomLastNameKana.$error}" v-model="state.groomLastNameKana" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                    <div class="invalid-feedback" v-for="error of v$.groomLastNameKana.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="customer-info-block col-sm-5 row">
                  <label for="groomFirstNameKana" class="control-label col-sm-12">メイ</label>
                  <div class="col-sm-12">
                    <input name="groomFirstNameKana" type="text" id="groomFirstNameKana" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.groomFirstNameKana.$error}" v-model="state.groomFirstNameKana" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                    <div class="invalid-feedback" v-for="error of v$.groomFirstNameKana.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-sm-1 row">
                  <div class="col-sm-12"></div>
                  <div class="w-100 text-end align-self-center pt-3">様</div>
                </div>
                <div class="customer-info-block col-sm-12 row mt-2">
                  <label for="groomPhoneNumber" class="control-label col-sm-12">お電話番号</label>
                  <div class="col-sm-7">
                    <input name="groomPhoneNumber" type="text" id="groomPhoneNumber" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.groomPhoneNumber.$error}" v-model="state.groomPhoneNumber" @change="loadValidate" maxLength="20" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                    <div class="invalid-feedback" v-for="error of v$.groomPhoneNumber.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="control-label col-sm-12 customer-info-label">
                  <label class="d-inline">メールアドレス</label>
                </div>
                <div class="customer-info-block col-sm-12 row">
                  <div class="col-sm-12">
                    <input name="mailAddress" type="text" id="mailAddress" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.mailAddress.$error}" v-model="state.mailAddress" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                    <div class="invalid-feedback" v-for="error of v$.mailAddress.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <h1 id="email-disp">{{state.mailAddress}}</h1>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 customer-info-label">
                  <BFormRadioGroup
                    v-model="state.shinroShinpu2"
                    name= "shinroShinpu2"
                    @change="onRadioChange('shinroShinpu2', state.shinroShinpu2)"
                    :disabled="!state.isOperationPossible"
                    :class="{'is-invalid': v$.shinroShinpu2.$error}"
                  >
                    <BFormRadio id="shinroShinpu2-shinro" value="shinro" class="big_radio d-inline-flex align-items-center" style="block-size: 1.5rem; inline-size: 1.5rem; margin-top: 25%;">
                      <label for="shinroShinpu2-shinro" class="form-check-label ms-1 customer-info-label fw-bold" :style="'font-size: 2rem;' + (state.shinroShinpu2 !== 'shinro' ? 'color: gray;' : 'color: black;')">ご新郎様</label>
                    </BFormRadio>
                    <BFormRadio id="shinroShinpu2-shinpu" value="shinpu" class="big_radio d-inline-flex align-items-center" style="block-size: 1.5rem; inline-size: 1.5rem; margin-top: 25%;">
                      <label for="shinroShinpu2-shinpu" class="form-check-label ms-1 customer-info-label fw-bold" :style="'font-size: 2rem;' + (state.shinroShinpu2 !== 'shinpu' ? 'color: gray;' : 'color: black;')">ご新婦様</label>
                    </BFormRadio>
                  </BFormRadioGroup>
                </div>
                <div class="customer-info-block col-sm-5 row">
                  <label for="brideLastName" class="control-label col-sm-12">姓<span class="required-color">（*）</span></label>
                  <div class="col-sm-12">
                    <input name="brideLastName" type="text" id="brideLastName" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.brideLastName.$error}" v-model="state.brideLastName" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                    <div class="invalid-feedback" v-for="error of v$.brideLastName.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="customer-info-block col-sm-5 row">
                  <label for="brideFirstName" class="control-label col-sm-12">名<span class="required-color">（*）</span></label>
                  <div class="col-sm-12">
                    <input name="brideFirstName" type="text" id="brideFirstName" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.brideFirstName.$error}" v-model="state.brideFirstName" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                    <div class="invalid-feedback" v-for="error of v$.brideFirstName.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-sm-1 row">
                  <div class="col-sm-12"></div>
                  <div class="w-100 text-end align-self-center pt-3">様</div>
                </div>
                <div class="customer-info-block col-sm-5 row mt-2">
                  <label for="brideLastNameKana" class="control-label col-sm-12">セイ</label>
                  <div class="col-sm-12">
                    <input name="brideLastNameKana" type="text" id="brideLastNameKana" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.brideLastNameKana.$error}" v-model="state.brideLastNameKana" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                    <div class="invalid-feedback" v-for="error of v$.brideLastNameKana.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="customer-info-block col-sm-5 row">
                  <label for="brideFirstNameKana" class="control-label col-sm-12">メイ</label>
                  <div class="col-sm-12">
                    <input name="brideFirstNameKana" type="text" id="brideFirstNameKana" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.brideFirstNameKana.$error}" v-model="state.brideFirstNameKana" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                    <div class="invalid-feedback" v-for="error of v$.brideFirstNameKana.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-sm-1 row">
                  <div class="col-sm-12"></div>
                  <div class="w-100 text-end align-self-center pt-3">様</div>
                </div>
                <div class="customer-info-block col-sm-12 row mt-2">
                  <label for="bridePhoneNumber" class="control-label col-sm-12">お電話番号</label>
                  <div class="col-sm-7">
                    <input name="bridePhoneNumber" type="text" id="bridePhoneNumber" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.bridePhoneNumber.$error}" v-model="state.bridePhoneNumber" @change="loadValidate" maxLength="20" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                    <div class="invalid-feedback" v-for="error of v$.bridePhoneNumber.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="control-label col-sm-12 customer-info-label">
                  <label class="d-inline">メールアドレス</label>
                </div>
                <div class="customer-info-block col-sm-12 row">
                  <div class="col-sm-12">
                    <input name="brideMailAddress" type="text" id="brideMailAddress" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : v$.brideMailAddress.$error}" v-model="state.brideMailAddress" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible"/>
                    <div class="invalid-feedback" v-for="error of v$.brideMailAddress.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <h1 id="email-disp">{{state.brideMailAddress}}</h1>
                </div>
              </div>
            </div>
          </form>
          <div class="text-end w-100 mb-3 me-5">
            <BButton variant="primary" class="w-25 ms-3 main-button-color next-button-disabled" @click="() => { console.log('clicked florist next'); nextPage() }" :disabled="!state.isOperationPossible">次へ</BButton>
          </div>
        </div>
      </div>
    </MeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>

<script>
import { reactive, computed, ref, getCurrentInstance, onMounted, onUnmounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { BFormRadioGroup, BFormRadio, BButton } from 'bootstrap-vue-next' // BootstrapVueNextコンポーネントを追加
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import MeetingLayout from '@/layout/MeetingLayout'
import fstore from '@/store/florist-store'
import CustomerInfoModel from '@/models/CustomerInfoModel'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import useVuelidate from '@vuelidate/core'
import { required, email, maxLength, integer, helpers } from '@vuelidate/validators'

// 日本語のカタカナチェック用カスタムバリデータ
const isKana = helpers.regex(/^[あ-んァ-ヶーA-Za-zＡ-Ｚａ-ｚ]*$/)

export default {
  name: 'FloristMeetingInput',
  components: { CommonLayout, MeetingLayout, CommonModal, BFormRadioGroup, BFormRadio, BButton }, // コンポーネント登録

  setup () {
    const router = useRouter()
    const { appContext } = getCurrentInstance()
    const { proxy } = getCurrentInstance()
    const gp = appContext?.config?.globalProperties || {}
    const config = gp.config ?? {}
    const consts = gp.consts ?? {}

    const commonRef = ref(null)
    const commonModal = ref(null)
    const onRadioChange = (name, value) => {
      sendSignalingInputData({ type: 'change', target: { id: name, name, type: 'radio', value } })
    }
    const halfWidth = helpers.regex(/^[\x20-\x7e]*$/)

    const state = reactive({
      bothFamilyName1: '',
      bothFamilyName2: '',
      shinroShinpu1: 'shinro',
      shinroShinpu2: 'shinpu',
      groomLastName: '',
      groomFirstName: '',
      groomLastNameKana: '',
      groomFirstNameKana: '',
      groomPhoneNumber: '',
      brideLastNameKana: '',
      brideFirstNameKana: '',
      brideLastName: '',
      brideFirstName: '',
      bridePhoneNumber: '',
      mailAddress: '',
      brideMailAddress: '',
      isOperationPossible: fstore.getters.isOperationPossible
    })
    const isMailAddressRequired = computed(() => helpers.withMessage(
      consts.validationMsg?.meetingInput?.mailAddress?.required || 'どちらかのメールアドレスは必須です',
      (value) => !!value || !!state.brideMailAddress
    ))
    const isBrideMailAddressRequired = computed(() => helpers.withMessage(
      consts.validationMsg?.meetingInput?.mailAddress?.required || 'どちらかのメールアドレスは必須です',
      (value) => !!value || !!state.mailAddress
    ))

    const rules = computed(() => ({
      bothFamilyName1: { required: helpers.withMessage(consts.validationMsg?.meetingInput?.bothFamilyName1?.required || 'ご両家様名1は必須です', required) },
      bothFamilyName2: { required: helpers.withMessage(consts.validationMsg?.meetingInput?.bothFamilyName2?.required || 'ご両家様名2は必須です', required) },
      shinroShinpu1: { required: helpers.withMessage('新郎新婦1の選択は必須です', required) },
      groomLastName: { required: helpers.withMessage(consts.validationMsg?.meetingInput?.groomLastName?.required || '新郎様の姓は必須です', required) },
      groomFirstName: { required: helpers.withMessage(consts.validationMsg?.meetingInput?.groomFirstName?.required || '新郎様の名は必須です', required) },
      groomLastNameKana: { isKana: helpers.withMessage(consts.validationMsg?.meetingInput?.groomLastNameKana?.kana || '新郎様のセイはカタカナで入力してください', isKana) },
      groomFirstNameKana: { isKana: helpers.withMessage(consts.validationMsg?.meetingInput?.groomFirstNameKana?.kana || '新郎様のメイはカタカナで入力してください', isKana) },
      groomPhoneNumber: {
        // required: helpers.withMessage(consts.validationMsg?.meetingInput?.groomPhoneNumber?.required || '新郎様のお電話番号は必須です', required), // お客様画面ではrequiredは不要
        maxLength: helpers.withMessage(consts.validationMsg?.meetingInput?.groomPhoneNumber?.maxLength || '20桁以内が有効です', maxLength(20)),
        phoneNumber: helpers.withMessage(consts.validationMsg?.meetingInput?.groomPhoneNumber?.phoneNumber || '電話番号には「半角数字、+、-、スペース」のみご入力ください', helpers.regex(/^[+]?[0-9\s-]+$/))
      },
      shinroShinpu2: { required: helpers.withMessage('新郎新婦2の選択は必須です', required) },
      brideLastName: { required: helpers.withMessage(consts.validationMsg?.meetingInput?.brideLastName?.required || '新婦様の姓は必須です', required) },
      brideFirstName: { required: helpers.withMessage(consts.validationMsg?.meetingInput?.brideFirstName?.required || '新婦様の名は必須です', required) },
      brideLastNameKana: { isKana: helpers.withMessage(consts.validationMsg?.meetingInput?.brideLastNameKana?.kana || '新婦様のセイはカタカナで入力してください', isKana) },
      brideFirstNameKana: { isKana: helpers.withMessage(consts.validationMsg?.meetingInput?.brideFirstNameKana?.kana || '新婦様のメイはカタカナで入力してください', isKana) },
      bridePhoneNumber: {
        // required: helpers.withMessage(consts.validationMsg?.meetingInput?.bridePhoneNumber?.required || '新婦様のお電話番号は必須です', required), // お客様画面ではrequiredは不要
        maxLength: helpers.withMessage(consts.validationMsg?.meetingInput?.bridePhoneNumber?.maxLength || '20桁以内が有効です', maxLength(20)),
        phoneNumber: helpers.withMessage(consts.validationMsg?.meetingInput?.bridePhoneNumber?.phoneNumber || '電話番号には「半角数字、+、-、スペース」のみご入力ください', helpers.regex(/^[+]?[0-9\s-]+$/))
      },
      mailAddress: {
        required: isMailAddressRequired.value, // カスタムバリデータ
        email: helpers.withMessage(consts.validationMsg?.meetingInput?.mailAddress?.email || 'Eメールの形式ではありません', email),
        halfWidth: helpers.withMessage(consts.validationMsg?.meetingInput?.mailAddress?.halfWidth || '半角で入力してください', helpers.regex(/^[" -~]*$/))
      },
      brideMailAddress: {
        required: isBrideMailAddressRequired.value, // カスタムバリデータ
        email: helpers.withMessage(consts.validationMsg?.meetingInput?.mailAddress?.email || 'Eメールの形式ではありません', email),
        halfWidth: helpers.withMessage(consts.validationMsg?.meetingInput?.mailAddress?.halfWidth || '半角で入力してください', helpers.regex(/^[" -~]*$/))
      }
    }))

    const v$ = useVuelidate(rules, state)

    const getSignalingData = computed(() => fstore.getters.signalingReceiveData)
    watch(getSignalingData, (n, o) => {
      console.log('[florist] watch fired (debug)', n)
    }, { immediate: true })
    const getIsOperationPossible = computed(() => fstore.getters.isOperationPossible)

    // watchでstate.isOperationPossibleを更新
    watch(getIsOperationPossible, (newVal) => {
      state.isOperationPossible = newVal
    })

    onMounted(() => {
      console.log('[florist] mounted FloristMeetingInput')
      const lastRoutePath = sessionStorage.getItem('lastRoutePath')
      if (lastRoutePath !== router.currentRoute.value.path) {
        fstore.commit('setIsOperationPossible', false)
        state.isOperationPossible = false
      }

      try {
        setApiData()
      } catch (err) {
        CommonLogModel.apiSetStore(null, { 'timestampMs': Date.now(), 'error': err }, () => { })
      }
    })

    // Vue 2のwatchをVue 3のwatchに変換
    watch(getSignalingData, (newData, oldData) => {
      console.log('[florist] receive', {
        op: state.isOperationPossible,
        event: newData?.event,
        id: newData?.id,
        dataLen: newData?.data?.length
      })

      try {
        newData['user'] = 'florist'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(null, newData, () => {})

        if (newData['current_path'] && oldData) {
          const synchPass = newData['current_path'].replace('customer', 'florist')
          if (synchPass !== router.currentRoute.value.path) {
            return router.push(synchPass)
          }
        }

        if (!state.isOperationPossible) {
          if (newData['event'] === 'click') {
            if (newData['id'] === 'next') {
              signalingNextPage(newData['target_path'])
            }
            if (newData['id'] === 'back') {
              backPage(newData['target_path'])
            }
          }
          if (newData['event'] === 'input') {
            for (const item of newData.data) {
              if (!item || !item.id) continue
              if (Object.prototype.hasOwnProperty.call(state, item.id)) {
                state[item.id] = item.value
                if (item.target) {
                  v$.value?.[item.id]?.$touch?.()
                }
                continue
              }
              const elm = document.getElementById(item.id)
              if (!elm) continue
              elm.value = item.value
              elm.dispatchEvent(new Event('input'))
              if (item.target) elm.dispatchEvent(new Event('change'))
            }
          }
        }
        if (newData['event'] === 'click') {
          if (newData['id'] === 'operationInvalid') {
            fstore.commit('setIsOperationPossible', false)
            state.isOperationPossible = false
          } else if (newData['id'] === 'operationPossible') {
            fstore.commit('setIsOperationPossible', true)
            state.isOperationPossible = true
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(null, { 'timestampMs': Date.now(), 'error': err }, () => { })
      }
    })

    const setApiData = async () => {
      try {
        const resData = await CustomerInfoModel.apiSetStore(commonModal.value, () => {})
        Object.assign(state, {
          bothFamilyName1: resData.bothFamilyName1,
          bothFamilyName2: resData.bothFamilyName2,
          shinroShinpu1: resData.shinroShinpu1,
          shinroShinpu2: resData.shinroShinpu2,
          groomLastName: resData.groomLastName,
          groomFirstName: resData.groomFirstName,
          groomLastNameKana: resData.groomLastNameKana,
          groomFirstNameKana: resData.groomFirstNameKana,
          groomPhoneNumber: resData.groomPhoneNumber,
          brideLastName: resData.brideLastName,
          brideFirstName: resData.brideFirstName,
          brideLastNameKana: resData.brideLastNameKana,
          brideFirstNameKana: resData.brideFirstNameKana,
          bridePhoneNumber: resData.bridePhoneNumber,
          mailAddress: resData.mailAddress,
          brideMailAddress: resData.brideMailAddress
        })
        // データロード後にVuelidateの検証をリセットし、初期状態をクリーンにする
        v$.value.$reset()
      } catch (err) {
        CommonLogModel.apiSetStore(null, { 'timestampMs': Date.now(), 'error': err }, () => {})
      }
    }

    const signalingKeys = [
      'bothFamilyName1', 'bothFamilyName2',
      'shinroShinpu1', 'shinroShinpu2',
      'groomLastName', 'groomFirstName', 'groomLastNameKana', 'groomFirstNameKana', 'groomPhoneNumber',
      'brideLastName', 'brideFirstName', 'brideLastNameKana', 'brideFirstNameKana', 'bridePhoneNumber',
      'mailAddress', 'brideMailAddress'
    ]

    const sendSignalingInputData = async (e) => {
      try {
        if (!state.isOperationPossible) return
        const targetId = e?.target?.id || e?.target?.name
        // validate touch
        if ((e?.type === 'blur' || e?.type === 'change') && targetId) {
          const validationKey = e?.target?.type === 'radio' ? e.target.name : targetId
          v$.value?.[validationKey]?.$touch?.()
        }
        const sendData = signalingKeys.map((id) => ({
          id,
          value: state[id]
        }))
        // どれが変更トリガーか分かるようにしたいなら
        if (targetId) {
          const t = sendData.find(x => x.id === targetId)
          if (t) t.target = true
        }
        // ★もし SignalingModel が Vue2 の this 前提なら proxy を渡す（null固定は危険）
        SignalingModel.sendInputEvent(proxy ?? null, sendData)
      } catch (err) {
        CommonLogModel.apiSetStore(null, { timestampMs: Date.now(), error: err }, () => {})
      }
    }
    const nextPage = async () => {
      const cookieProjectNumberCheckResult = await commonRef.value.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        commonModal.value.msgBoxOk(consts.errorMsg?.otherCookieProjectNumber || 'セッションが切れました。')
        return false
      }

      const isFormValid = await v$.value.$validate()
      if (!isFormValid) {
        // バリデーションエラーがある場合は、エラーメッセージを表示するためにスクロール
        const firstErrorElement = document.querySelector('.is-invalid')
        if (firstErrorElement) {
          firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        return false
      }

      const targetPath = '/florist/meeting/confirm'
      try {
        SignalingModel.sendClickEvent('next', proxy, {'target_path': targetPath.replace('florist', 'customer')})

        state.mailAddress = state.mailAddress ? state.mailAddress.trim() : ''
        state.brideMailAddress = state.brideMailAddress ? state.brideMailAddress.trim() : ''

        fstore.commit('setBothFamilyName1', state.bothFamilyName1)
        fstore.commit('setBothFamilyName2', state.bothFamilyName2)
        fstore.commit('setGroomLastName', state.groomLastName)
        fstore.commit('setGroomFirstName', state.groomFirstName)
        fstore.commit('setGroomLastNameKana', state.groomLastNameKana)
        fstore.commit('setGroomFirstNameKana', state.groomFirstNameKana)
        fstore.commit('setGroomPhoneNumber', state.groomPhoneNumber)
        fstore.commit('setBrideLastName', state.brideLastName)
        fstore.commit('setBrideFirstName', state.brideFirstName)
        fstore.commit('setBrideLastNameKana', state.brideLastNameKana)
        fstore.commit('setBrideFirstNameKana', state.brideFirstNameKana)
        fstore.commit('setBridePhoneNumber', state.bridePhoneNumber)
        fstore.commit('setMailAddress', state.mailAddress)
        fstore.commit('setBrideMailAddress', state.brideMailAddress)
        fstore.commit('setShinroShinpu1', state.shinroShinpu1)
        fstore.commit('setShinroShinpu2', state.shinroShinpu2)
        fstore.commit('setIsOperationPossible', true)
        router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(null, { 'timestampMs': Date.now(), 'error': err }, () => {})
        return false
      }
    }

    const signalingNextPage = async (targetPath) => {
      try {
        const isFormValid = await v$.value.$validate()
        if (!isFormValid) {
          const firstErrorElement = document.querySelector('.is-invalid')
          if (firstErrorElement) {
            firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
          return false
        }

        fstore.commit('setBothFamilyName1', state.bothFamilyName1)
        fstore.commit('setBothFamilyName2', state.bothFamilyName2)
        fstore.commit('setGroomLastName', state.groomLastName)
        fstore.commit('setGroomFirstName', state.groomFirstName)
        fstore.commit('setGroomLastNameKana', state.groomLastNameKana)
        fstore.commit('setGroomFirstNameKana', state.groomFirstNameKana)
        fstore.commit('setGroomPhoneNumber', state.groomPhoneNumber)
        fstore.commit('setBrideLastName', state.brideLastName)
        fstore.commit('setBrideFirstName', state.brideFirstName)
        fstore.commit('setBrideLastNameKana', state.brideLastNameKana)
        fstore.commit('setBrideFirstNameKana', state.brideFirstNameKana)
        fstore.commit('setBridePhoneNumber', state.bridePhoneNumber)
        fstore.commit('setMailAddress', state.mailAddress)
        fstore.commit('setBrideMailAddress', state.brideMailAddress)
        fstore.commit('setShinroShinpu1', state.shinroShinpu1)
        fstore.commit('setShinroShinpu2', state.shinroShinpu2)
        fstore.commit('setIsOperationPossible', false)
        router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(null, { 'timestampMs': Date.now(), 'error': err }, () => {})
        return false
      }
    }

    const backPage = (targetPath) => {
      try {
        const customerTargetPath = targetPath || '/customer/meeting/agenda'
        SignalingModel.sendClickEvent('back', null, {'target_path': customerTargetPath.replace('customer', 'florist')})
        router.push(customerTargetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(null, { 'timestampMs': Date.now(), 'error': err }, () => {})
      }
    }

    const loadValidate = async (e) => {
      try {
        if (e?.target) {
          const validationKey = e.target.type === 'radio' ? e.target.name : e.target.id
          v$.value?.[validationKey]?.$touch?.()
        }
      } catch (err) { /* ... */ }
    }

    return {
      state,
      v$,
      commonRef,
      commonModal,
      config,
      consts,
      setApiData,
      sendSignalingInputData,
      nextPage,
      signalingNextPage,
      backPage,
      loadValidate,
      onRadioChange
    }
  }
}
</script>

<style scoped type="text/css">
  label {
    margin-bottom: 1px;
  }
  input[type=radio] {
    transform: scale(2);
  }
  .form-control:disabled {
    background-color: #fff;
  }
  .next-button-disabled:disabled {
  background-color: rgb(0, 123, 255);
  color: #fff;
  opacity: 1;
  }
  .big_radio {
  accent-color:#007bff;
  top:10px;
  margin-top: 24px;
  }
</style>
